var map = {
	"./ggi-1.svg": 86074,
	"./ggi-10.svg": 15558,
	"./ggi-11.svg": 78359,
	"./ggi-12.svg": 73764,
	"./ggi-13.svg": 51781,
	"./ggi-14.svg": 16858,
	"./ggi-15.svg": 22123,
	"./ggi-16.svg": 83288,
	"./ggi-17.svg": 58793,
	"./ggi-18.svg": 48238,
	"./ggi-19.svg": 86175,
	"./ggi-2.svg": 11657,
	"./ggi-20.svg": 69211,
	"./ggi-21.svg": 27242,
	"./ggi-22.svg": 69593,
	"./ggi-23.svg": 87848,
	"./ggi-24.svg": 25447,
	"./ggi-25.svg": 85910,
	"./ggi-26.svg": 98869,
	"./ggi-27.svg": 53940,
	"./ggi-28.svg": 10979,
	"./ggi-29.svg": 61586,
	"./ggi-3.svg": 36152,
	"./ggi-30.svg": 55192,
	"./ggi-31.svg": 43081,
	"./ggi-32.svg": 74970,
	"./ggi-4.svg": 31223,
	"./ggi-5.svg": 84774,
	"./ggi-6.svg": 4645,
	"./ggi-7.svg": 26628,
	"./ggi-8.svg": 16755,
	"./ggi-9.svg": 2530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19588;